"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatesAndFees = void 0;

var _react = _interopRequireDefault(require("react"));

var _detailsTabs = require("../common/details-tabs");

var _detailsList = require("./details-list");

var _jsxRuntime = require("react/jsx-runtime");

var RatesAndFees = function RatesAndFees(_ref) {
  var _creditCardOffer$aprs, _creditCardOffer$aprs2, _creditCardOffer$aprs3, _creditCardOffer$aprs4, _creditCardOffer$fees, _creditCardOffer$fees2, _creditCardOffer$fees3, _creditCardOffer$fees4, _creditCardOffer$rewa, _creditCardOffer$rewa2, _creditCardOffer$rewa3, _creditCardOffer$rewa4;

  var creditCardOffer = _ref.creditCardOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = 'Rates and Fees';
  var details = [(_creditCardOffer$aprs = (_creditCardOffer$aprs2 = creditCardOffer.aprs) === null || _creditCardOffer$aprs2 === void 0 ? void 0 : _creditCardOffer$aprs2.introPurchaseApr) !== null && _creditCardOffer$aprs !== void 0 ? _creditCardOffer$aprs : null, (_creditCardOffer$aprs3 = (_creditCardOffer$aprs4 = creditCardOffer.aprs) === null || _creditCardOffer$aprs4 === void 0 ? void 0 : _creditCardOffer$aprs4.purchaseApr) !== null && _creditCardOffer$aprs3 !== void 0 ? _creditCardOffer$aprs3 : null, (_creditCardOffer$fees = (_creditCardOffer$fees2 = creditCardOffer.fees) === null || _creditCardOffer$fees2 === void 0 ? void 0 : _creditCardOffer$fees2.annualFee) !== null && _creditCardOffer$fees !== void 0 ? _creditCardOffer$fees : null, (_creditCardOffer$fees3 = (_creditCardOffer$fees4 = creditCardOffer.fees) === null || _creditCardOffer$fees4 === void 0 ? void 0 : _creditCardOffer$fees4.foreignTransactionFee) !== null && _creditCardOffer$fees3 !== void 0 ? _creditCardOffer$fees3 : null, (_creditCardOffer$rewa = (_creditCardOffer$rewa2 = creditCardOffer.rewards) === null || _creditCardOffer$rewa2 === void 0 ? void 0 : _creditCardOffer$rewa2.rewardsRate) !== null && _creditCardOffer$rewa !== void 0 ? _creditCardOffer$rewa : null, (_creditCardOffer$rewa3 = (_creditCardOffer$rewa4 = creditCardOffer.rewards) === null || _creditCardOffer$rewa4 === void 0 ? void 0 : _creditCardOffer$rewa4.welcomeOffer) !== null && _creditCardOffer$rewa3 !== void 0 ? _creditCardOffer$rewa3 : null].filter(function (val) {
    return val != null;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      handleShownTab: handleShownTab,
      title: title
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsList.DetailsList, {
      items: details
    })]
  });
};

exports.RatesAndFees = RatesAndFees;
//# sourceMappingURL=rates-and-fees.js.map